var Nn = Object.defineProperty;
var Ln = (e, t, n) => t in e ? Nn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var I = (e, t, n) => (Ln(e, typeof t != "symbol" ? t + "" : t, n), n);
const H = [
  { w: 300, h: 250, prefix: "MPU" },
  { w: 300, h: 600, prefix: "Monster MPU" },
  { w: 728, h: 90, prefix: "Leaderboard" },
  { w: 970, h: 90, prefix: "Large Leaderboard" },
  { w: 320, h: 50, prefix: "Mobile Leaderboard" },
  { w: 120, h: 600, prefix: "Skyscraper" },
  { w: 160, h: 600, prefix: "Wide Skyscraper" },
  { w: 970, h: 250, prefix: "Billboard" },
  { w: 234, h: 60, prefix: "Half Banner" },
  { w: 468, h: 60, prefix: "Full Banner" },
  { w: 120, h: 240, prefix: "Vertical Banner" },
  { w: 250, h: 250, prefix: "Square" },
  { w: 200, h: 200, prefix: "Small Square" },
  { w: 180, h: 150, prefix: "Small Rectangle" },
  { w: 300, h: 250, prefix: "Medium Rectangle" },
  { w: 336, h: 280, prefix: "Large Rectangle" },
  { w: 300, h: 600, prefix: "Half Page" },
  { w: 468, h: 60, prefix: "Banner" },
  { w: 120, h: 60, prefix: "Button" },
  { w: 300, h: 50, prefix: "" },
  { w: 300, h: 100, prefix: "" },
  { w: 300, h: 300, prefix: "" },
  { w: 320, h: 480, prefix: "" },
  { w: 320, h: 100, prefix: "" },
  { w: 320, h: 250, prefix: "" },
  { w: 480, h: 320, prefix: "" }
];
function Bn(e, t, n, r) {
  const i = e.w + r.width, s = e.h + r.height;
  return i <= t.width && s <= t.height || i <= t.width && s <= n.height ? !0 : s <= t.height && i <= n.width;
}
const Vt = "ERR_NO_AD_FILL", Dn = "ERR_INVALID_PARTNER", Un = "ERR_NOT_IN_VIEWPORT", Ie = "ERR_MISSING_REQUIRED_OPTION";
class z extends Error {
  constructor(t, n) {
    super(t), this.code = n, this.code = n;
  }
}
function $n(e, t) {
  const n = 1.61803398875, r = e / n, i = t / n, s = (e - r) / 2, o = (t - i) / 2;
  return {
    width: Math.trunc(s),
    height: Math.trunc(o)
  };
}
function Yc(e, t, n, r) {
  if (r)
    return r;
  if (!e)
    return;
  const i = parseInt(e.width), s = parseInt(e.height), o = $n(i, s), a = [];
  return H.forEach((l) => {
    Bn(l, o, { width: i, height: s }, n) && a.push(l);
  }), a.length === 0 && t && a.push({ w: 320, h: 50 }), a;
}
var Mn = typeof global == "object" && global && global.Object === Object && global;
const Jt = Mn;
var Fn = typeof self == "object" && self && self.Object === Object && self, jn = Jt || Fn || Function("return this")();
const U = jn;
var Hn = U.Symbol;
const j = Hn;
var Kt = Object.prototype, qn = Kt.hasOwnProperty, zn = Kt.toString, Q = j ? j.toStringTag : void 0;
function Gn(e) {
  var t = qn.call(e, Q), n = e[Q];
  try {
    e[Q] = void 0;
    var r = !0;
  } catch {
  }
  var i = zn.call(e);
  return r && (t ? e[Q] = n : delete e[Q]), i;
}
var Wn = Object.prototype, Vn = Wn.toString;
function Jn(e) {
  return Vn.call(e);
}
var Kn = "[object Null]", kn = "[object Undefined]", ct = j ? j.toStringTag : void 0;
function Y(e) {
  return e == null ? e === void 0 ? kn : Kn : ct && ct in Object(e) ? Gn(e) : Jn(e);
}
function K(e) {
  return e != null && typeof e == "object";
}
var Yn = "[object Symbol]";
function ze(e) {
  return typeof e == "symbol" || K(e) && Y(e) == Yn;
}
function Xn(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Qn = Array.isArray;
const C = Qn;
var Zn = 1 / 0, ut = j ? j.prototype : void 0, lt = ut ? ut.toString : void 0;
function kt(e) {
  if (typeof e == "string")
    return e;
  if (C(e))
    return Xn(e, kt) + "";
  if (ze(e))
    return lt ? lt.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Zn ? "-0" : t;
}
function te(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function er(e) {
  return e;
}
var tr = "[object AsyncFunction]", nr = "[object Function]", rr = "[object GeneratorFunction]", ir = "[object Proxy]";
function Yt(e) {
  if (!te(e))
    return !1;
  var t = Y(e);
  return t == nr || t == rr || t == tr || t == ir;
}
var sr = U["__core-js_shared__"];
const Oe = sr;
var dt = function() {
  var e = /[^.]+$/.exec(Oe && Oe.keys && Oe.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function or(e) {
  return !!dt && dt in e;
}
var ar = Function.prototype, cr = ar.toString;
function W(e) {
  if (e != null) {
    try {
      return cr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ur = /[\\^$.*+?()[\]{}|]/g, lr = /^\[object .+?Constructor\]$/, dr = Function.prototype, fr = Object.prototype, pr = dr.toString, hr = fr.hasOwnProperty, mr = RegExp(
  "^" + pr.call(hr).replace(ur, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function yr(e) {
  if (!te(e) || or(e))
    return !1;
  var t = Yt(e) ? mr : lr;
  return t.test(W(e));
}
function gr(e, t) {
  return e == null ? void 0 : e[t];
}
function V(e, t) {
  var n = gr(e, t);
  return yr(n) ? n : void 0;
}
var br = V(U, "WeakMap");
const Le = br;
function wr() {
}
var Er = function() {
  try {
    var e = V(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const ft = Er;
function Ar(e, t, n, r) {
  for (var i = e.length, s = n + (r ? 1 : -1); r ? s-- : ++s < i; )
    if (t(e[s], s, e))
      return s;
  return -1;
}
function _r(e) {
  return e !== e;
}
function Sr(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
function Tr(e, t, n) {
  return t === t ? Sr(e, t, n) : Ar(e, _r, n);
}
function Ir(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && Tr(e, t, 0) > -1;
}
var Or = 9007199254740991, xr = /^(?:0|[1-9]\d*)$/;
function Ge(e, t) {
  var n = typeof e;
  return t = t ?? Or, !!t && (n == "number" || n != "symbol" && xr.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Rr(e, t, n) {
  t == "__proto__" && ft ? ft(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function We(e, t) {
  return e === t || e !== e && t !== t;
}
var vr = Object.prototype, Pr = vr.hasOwnProperty;
function Cr(e, t, n) {
  var r = e[t];
  (!(Pr.call(e, t) && We(r, n)) || n === void 0 && !(t in e)) && Rr(e, t, n);
}
var Nr = 9007199254740991;
function Ve(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Nr;
}
function Xt(e) {
  return e != null && Ve(e.length) && !Yt(e);
}
var Lr = Object.prototype;
function Br(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Lr;
  return e === n;
}
function Dr(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Ur = "[object Arguments]";
function pt(e) {
  return K(e) && Y(e) == Ur;
}
var Qt = Object.prototype, $r = Qt.hasOwnProperty, Mr = Qt.propertyIsEnumerable, Fr = pt(function() {
  return arguments;
}()) ? pt : function(e) {
  return K(e) && $r.call(e, "callee") && !Mr.call(e, "callee");
};
const Zt = Fr;
function jr() {
  return !1;
}
var en = typeof exports == "object" && exports && !exports.nodeType && exports, ht = en && typeof module == "object" && module && !module.nodeType && module, Hr = ht && ht.exports === en, mt = Hr ? U.Buffer : void 0, qr = mt ? mt.isBuffer : void 0, zr = qr || jr;
const Be = zr;
var Gr = "[object Arguments]", Wr = "[object Array]", Vr = "[object Boolean]", Jr = "[object Date]", Kr = "[object Error]", kr = "[object Function]", Yr = "[object Map]", Xr = "[object Number]", Qr = "[object Object]", Zr = "[object RegExp]", ei = "[object Set]", ti = "[object String]", ni = "[object WeakMap]", ri = "[object ArrayBuffer]", ii = "[object DataView]", si = "[object Float32Array]", oi = "[object Float64Array]", ai = "[object Int8Array]", ci = "[object Int16Array]", ui = "[object Int32Array]", li = "[object Uint8Array]", di = "[object Uint8ClampedArray]", fi = "[object Uint16Array]", pi = "[object Uint32Array]", w = {};
w[si] = w[oi] = w[ai] = w[ci] = w[ui] = w[li] = w[di] = w[fi] = w[pi] = !0;
w[Gr] = w[Wr] = w[ri] = w[Vr] = w[ii] = w[Jr] = w[Kr] = w[kr] = w[Yr] = w[Xr] = w[Qr] = w[Zr] = w[ei] = w[ti] = w[ni] = !1;
function hi(e) {
  return K(e) && Ve(e.length) && !!w[Y(e)];
}
function mi(e) {
  return function(t) {
    return e(t);
  };
}
var tn = typeof exports == "object" && exports && !exports.nodeType && exports, ee = tn && typeof module == "object" && module && !module.nodeType && module, yi = ee && ee.exports === tn, xe = yi && Jt.process, gi = function() {
  try {
    var e = ee && ee.require && ee.require("util").types;
    return e || xe && xe.binding && xe.binding("util");
  } catch {
  }
}();
const yt = gi;
var gt = yt && yt.isTypedArray, bi = gt ? mi(gt) : hi;
const nn = bi;
var wi = Object.prototype, Ei = wi.hasOwnProperty;
function Ai(e, t) {
  var n = C(e), r = !n && Zt(e), i = !n && !r && Be(e), s = !n && !r && !i && nn(e), o = n || r || i || s, a = o ? Dr(e.length, String) : [], l = a.length;
  for (var c in e)
    (t || Ei.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Ge(c, l))) && a.push(c);
  return a;
}
function _i(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Si = _i(Object.keys, Object);
const Ti = Si;
var Ii = Object.prototype, Oi = Ii.hasOwnProperty;
function xi(e) {
  if (!Br(e))
    return Ti(e);
  var t = [];
  for (var n in Object(e))
    Oi.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Je(e) {
  return Xt(e) ? Ai(e) : xi(e);
}
var Ri = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vi = /^\w*$/;
function Ke(e, t) {
  if (C(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ze(e) ? !0 : vi.test(e) || !Ri.test(e) || t != null && e in Object(t);
}
var Pi = V(Object, "create");
const ne = Pi;
function Ci() {
  this.__data__ = ne ? ne(null) : {}, this.size = 0;
}
function Ni(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Li = "__lodash_hash_undefined__", Bi = Object.prototype, Di = Bi.hasOwnProperty;
function Ui(e) {
  var t = this.__data__;
  if (ne) {
    var n = t[e];
    return n === Li ? void 0 : n;
  }
  return Di.call(t, e) ? t[e] : void 0;
}
var $i = Object.prototype, Mi = $i.hasOwnProperty;
function Fi(e) {
  var t = this.__data__;
  return ne ? t[e] !== void 0 : Mi.call(t, e);
}
var ji = "__lodash_hash_undefined__";
function Hi(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ne && t === void 0 ? ji : t, this;
}
function G(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
G.prototype.clear = Ci;
G.prototype.delete = Ni;
G.prototype.get = Ui;
G.prototype.has = Fi;
G.prototype.set = Hi;
function qi() {
  this.__data__ = [], this.size = 0;
}
function ge(e, t) {
  for (var n = e.length; n--; )
    if (We(e[n][0], t))
      return n;
  return -1;
}
var zi = Array.prototype, Gi = zi.splice;
function Wi(e) {
  var t = this.__data__, n = ge(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Gi.call(t, n, 1), --this.size, !0;
}
function Vi(e) {
  var t = this.__data__, n = ge(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Ji(e) {
  return ge(this.__data__, e) > -1;
}
function Ki(e, t) {
  var n = this.__data__, r = ge(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function $(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
$.prototype.clear = qi;
$.prototype.delete = Wi;
$.prototype.get = Vi;
$.prototype.has = Ji;
$.prototype.set = Ki;
var ki = V(U, "Map");
const re = ki;
function Yi() {
  this.size = 0, this.__data__ = {
    hash: new G(),
    map: new (re || $)(),
    string: new G()
  };
}
function Xi(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function be(e, t) {
  var n = e.__data__;
  return Xi(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Qi(e) {
  var t = be(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Zi(e) {
  return be(this, e).get(e);
}
function es(e) {
  return be(this, e).has(e);
}
function ts(e, t) {
  var n = be(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function M(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
M.prototype.clear = Yi;
M.prototype.delete = Qi;
M.prototype.get = Zi;
M.prototype.has = es;
M.prototype.set = ts;
var ns = "Expected a function";
function ke(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(ns);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], s = n.cache;
    if (s.has(i))
      return s.get(i);
    var o = e.apply(this, r);
    return n.cache = s.set(i, o) || s, o;
  };
  return n.cache = new (ke.Cache || M)(), n;
}
ke.Cache = M;
var rs = 500;
function is(e) {
  var t = ke(e, function(r) {
    return n.size === rs && n.clear(), r;
  }), n = t.cache;
  return t;
}
var ss = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, os = /\\(\\)?/g, as = is(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(ss, function(n, r, i, s) {
    t.push(i ? s.replace(os, "$1") : r || n);
  }), t;
});
const cs = as;
function us(e) {
  return e == null ? "" : kt(e);
}
function Ye(e, t) {
  return C(e) ? e : Ke(e, t) ? [e] : cs(us(e));
}
var ls = 1 / 0;
function oe(e) {
  if (typeof e == "string" || ze(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -ls ? "-0" : t;
}
function rn(e, t) {
  t = Ye(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[oe(t[n++])];
  return n && n == r ? e : void 0;
}
function De(e, t, n) {
  var r = e == null ? void 0 : rn(e, t);
  return r === void 0 ? n : r;
}
function ds(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
function fs() {
  this.__data__ = new $(), this.size = 0;
}
function ps(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function hs(e) {
  return this.__data__.get(e);
}
function ms(e) {
  return this.__data__.has(e);
}
var ys = 200;
function gs(e, t) {
  var n = this.__data__;
  if (n instanceof $) {
    var r = n.__data__;
    if (!re || r.length < ys - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new M(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function B(e) {
  var t = this.__data__ = new $(e);
  this.size = t.size;
}
B.prototype.clear = fs;
B.prototype.delete = ps;
B.prototype.get = hs;
B.prototype.has = ms;
B.prototype.set = gs;
function bs(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, s = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (s[i++] = o);
  }
  return s;
}
function ws() {
  return [];
}
var Es = Object.prototype, As = Es.propertyIsEnumerable, bt = Object.getOwnPropertySymbols, _s = bt ? function(e) {
  return e == null ? [] : (e = Object(e), bs(bt(e), function(t) {
    return As.call(e, t);
  }));
} : ws;
const Ss = _s;
function Ts(e, t, n) {
  var r = t(e);
  return C(e) ? r : ds(r, n(e));
}
function wt(e) {
  return Ts(e, Je, Ss);
}
var Is = V(U, "DataView");
const Ue = Is;
var Os = V(U, "Promise");
const $e = Os;
var xs = V(U, "Set");
const J = xs;
var Et = "[object Map]", Rs = "[object Object]", At = "[object Promise]", _t = "[object Set]", St = "[object WeakMap]", Tt = "[object DataView]", vs = W(Ue), Ps = W(re), Cs = W($e), Ns = W(J), Ls = W(Le), q = Y;
(Ue && q(new Ue(new ArrayBuffer(1))) != Tt || re && q(new re()) != Et || $e && q($e.resolve()) != At || J && q(new J()) != _t || Le && q(new Le()) != St) && (q = function(e) {
  var t = Y(e), n = t == Rs ? e.constructor : void 0, r = n ? W(n) : "";
  if (r)
    switch (r) {
      case vs:
        return Tt;
      case Ps:
        return Et;
      case Cs:
        return At;
      case Ns:
        return _t;
      case Ls:
        return St;
    }
  return t;
});
const It = q;
var Bs = U.Uint8Array;
const Ot = Bs;
var Ds = "__lodash_hash_undefined__";
function Us(e) {
  return this.__data__.set(e, Ds), this;
}
function $s(e) {
  return this.__data__.has(e);
}
function ie(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new M(); ++t < n; )
    this.add(e[t]);
}
ie.prototype.add = ie.prototype.push = Us;
ie.prototype.has = $s;
function Ms(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function sn(e, t) {
  return e.has(t);
}
var Fs = 1, js = 2;
function on(e, t, n, r, i, s) {
  var o = n & Fs, a = e.length, l = t.length;
  if (a != l && !(o && l > a))
    return !1;
  var c = s.get(e), d = s.get(t);
  if (c && d)
    return c == t && d == e;
  var p = -1, m = !0, y = n & js ? new ie() : void 0;
  for (s.set(e, t), s.set(t, e); ++p < a; ) {
    var f = e[p], h = t[p];
    if (r)
      var A = o ? r(h, f, p, t, e, s) : r(f, h, p, e, t, s);
    if (A !== void 0) {
      if (A)
        continue;
      m = !1;
      break;
    }
    if (y) {
      if (!Ms(t, function(E, b) {
        if (!sn(y, b) && (f === E || i(f, E, n, r, s)))
          return y.push(b);
      })) {
        m = !1;
        break;
      }
    } else if (!(f === h || i(f, h, n, r, s))) {
      m = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), m;
}
function Hs(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function Xe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var qs = 1, zs = 2, Gs = "[object Boolean]", Ws = "[object Date]", Vs = "[object Error]", Js = "[object Map]", Ks = "[object Number]", ks = "[object RegExp]", Ys = "[object Set]", Xs = "[object String]", Qs = "[object Symbol]", Zs = "[object ArrayBuffer]", eo = "[object DataView]", xt = j ? j.prototype : void 0, Re = xt ? xt.valueOf : void 0;
function to(e, t, n, r, i, s, o) {
  switch (n) {
    case eo:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Zs:
      return !(e.byteLength != t.byteLength || !s(new Ot(e), new Ot(t)));
    case Gs:
    case Ws:
    case Ks:
      return We(+e, +t);
    case Vs:
      return e.name == t.name && e.message == t.message;
    case ks:
    case Xs:
      return e == t + "";
    case Js:
      var a = Hs;
    case Ys:
      var l = r & qs;
      if (a || (a = Xe), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      r |= zs, o.set(e, t);
      var d = on(a(e), a(t), r, i, s, o);
      return o.delete(e), d;
    case Qs:
      if (Re)
        return Re.call(e) == Re.call(t);
  }
  return !1;
}
var no = 1, ro = Object.prototype, io = ro.hasOwnProperty;
function so(e, t, n, r, i, s) {
  var o = n & no, a = wt(e), l = a.length, c = wt(t), d = c.length;
  if (l != d && !o)
    return !1;
  for (var p = l; p--; ) {
    var m = a[p];
    if (!(o ? m in t : io.call(t, m)))
      return !1;
  }
  var y = s.get(e), f = s.get(t);
  if (y && f)
    return y == t && f == e;
  var h = !0;
  s.set(e, t), s.set(t, e);
  for (var A = o; ++p < l; ) {
    m = a[p];
    var E = e[m], b = t[m];
    if (r)
      var S = o ? r(b, E, m, t, e, s) : r(E, b, m, e, t, s);
    if (!(S === void 0 ? E === b || i(E, b, n, r, s) : S)) {
      h = !1;
      break;
    }
    A || (A = m == "constructor");
  }
  if (h && !A) {
    var O = e.constructor, v = t.constructor;
    O != v && "constructor" in e && "constructor" in t && !(typeof O == "function" && O instanceof O && typeof v == "function" && v instanceof v) && (h = !1);
  }
  return s.delete(e), s.delete(t), h;
}
var oo = 1, Rt = "[object Arguments]", vt = "[object Array]", le = "[object Object]", ao = Object.prototype, Pt = ao.hasOwnProperty;
function co(e, t, n, r, i, s) {
  var o = C(e), a = C(t), l = o ? vt : It(e), c = a ? vt : It(t);
  l = l == Rt ? le : l, c = c == Rt ? le : c;
  var d = l == le, p = c == le, m = l == c;
  if (m && Be(e)) {
    if (!Be(t))
      return !1;
    o = !0, d = !1;
  }
  if (m && !d)
    return s || (s = new B()), o || nn(e) ? on(e, t, n, r, i, s) : to(e, t, l, n, r, i, s);
  if (!(n & oo)) {
    var y = d && Pt.call(e, "__wrapped__"), f = p && Pt.call(t, "__wrapped__");
    if (y || f) {
      var h = y ? e.value() : e, A = f ? t.value() : t;
      return s || (s = new B()), i(h, A, n, r, s);
    }
  }
  return m ? (s || (s = new B()), so(e, t, n, r, i, s)) : !1;
}
function Qe(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !K(e) && !K(t) ? e !== e && t !== t : co(e, t, n, r, Qe, i);
}
var uo = 1, lo = 2;
function fo(e, t, n, r) {
  var i = n.length, s = i, o = !r;
  if (e == null)
    return !s;
  for (e = Object(e); i--; ) {
    var a = n[i];
    if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++i < s; ) {
    a = n[i];
    var l = a[0], c = e[l], d = a[1];
    if (o && a[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var p = new B();
      if (r)
        var m = r(c, d, l, e, t, p);
      if (!(m === void 0 ? Qe(d, c, uo | lo, r, p) : m))
        return !1;
    }
  }
  return !0;
}
function an(e) {
  return e === e && !te(e);
}
function po(e) {
  for (var t = Je(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, an(i)];
  }
  return t;
}
function cn(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function ho(e) {
  var t = po(e);
  return t.length == 1 && t[0][2] ? cn(t[0][0], t[0][1]) : function(n) {
    return n === e || fo(n, e, t);
  };
}
function mo(e, t) {
  return e != null && t in Object(e);
}
function yo(e, t, n) {
  t = Ye(t, e);
  for (var r = -1, i = t.length, s = !1; ++r < i; ) {
    var o = oe(t[r]);
    if (!(s = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return s || ++r != i ? s : (i = e == null ? 0 : e.length, !!i && Ve(i) && Ge(o, i) && (C(e) || Zt(e)));
}
function go(e, t) {
  return e != null && yo(e, t, mo);
}
var bo = 1, wo = 2;
function Eo(e, t) {
  return Ke(e) && an(t) ? cn(oe(e), t) : function(n) {
    var r = De(n, e);
    return r === void 0 && r === t ? go(n, e) : Qe(t, r, bo | wo);
  };
}
function Ao(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function _o(e) {
  return function(t) {
    return rn(t, e);
  };
}
function So(e) {
  return Ke(e) ? Ao(oe(e)) : _o(e);
}
function To(e) {
  return typeof e == "function" ? e : e == null ? er : typeof e == "object" ? C(e) ? Eo(e[0], e[1]) : ho(e) : So(e);
}
function Io(e, t, n, r) {
  for (var i = -1, s = e == null ? 0 : e.length; ++i < s; ) {
    var o = e[i];
    t(r, o, n(o), e);
  }
  return r;
}
function Oo(e) {
  return function(t, n, r) {
    for (var i = -1, s = Object(t), o = r(t), a = o.length; a--; ) {
      var l = o[e ? a : ++i];
      if (n(s[l], l, s) === !1)
        break;
    }
    return t;
  };
}
var xo = Oo();
const Ro = xo;
function vo(e, t) {
  return e && Ro(e, t, Je);
}
function Po(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Xt(n))
      return e(n, r);
    for (var i = n.length, s = t ? i : -1, o = Object(n); (t ? s-- : ++s < i) && r(o[s], s, o) !== !1; )
      ;
    return n;
  };
}
var Co = Po(vo);
const No = Co;
function Lo(e, t, n, r) {
  return No(e, function(i, s, o) {
    t(r, i, n(i), o);
  }), r;
}
function Bo(e, t) {
  return function(n, r) {
    var i = C(n) ? Io : Lo, s = t ? t() : {};
    return i(n, e, To(r), s);
  };
}
function Do(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
function Uo(e, t, n, r) {
  if (!te(e))
    return e;
  t = Ye(t, e);
  for (var i = -1, s = t.length, o = s - 1, a = e; a != null && ++i < s; ) {
    var l = oe(t[i]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (i != o) {
      var d = a[l];
      c = r ? r(d, l, a) : void 0, c === void 0 && (c = te(d) ? d : Ge(t[i + 1]) ? [] : {});
    }
    Cr(a, l, c), a = a[l];
  }
  return e;
}
var $o = Bo(function(e, t, n) {
  e[n ? 0 : 1].push(t);
}, function() {
  return [[], []];
});
const Mo = $o;
function Fo(e, t, n) {
  return e == null ? e : Uo(e, t, n);
}
var jo = 1 / 0, Ho = J && 1 / Xe(new J([, -0]))[1] == jo ? function(e) {
  return new J(e);
} : wr;
const qo = Ho;
var zo = 200;
function Go(e, t, n) {
  var r = -1, i = Ir, s = e.length, o = !0, a = [], l = a;
  if (n)
    o = !1, i = Do;
  else if (s >= zo) {
    var c = t ? null : qo(e);
    if (c)
      return Xe(c);
    o = !1, i = sn, l = new ie();
  } else
    l = t ? [] : a;
  e:
    for (; ++r < s; ) {
      var d = e[r], p = t ? t(d) : d;
      if (d = n || d !== 0 ? d : 0, o && p === p) {
        for (var m = l.length; m--; )
          if (l[m] === p)
            continue e;
        t && l.push(p), a.push(d);
      } else
        i(l, p, n) || (l !== a && l.push(p), a.push(d));
    }
  return a;
}
function Wo(e) {
  return e && e.length ? Go(e) : [];
}
function Xc(e) {
  if (!e)
    return {};
  const t = [], { campaign: n, distribution: r } = e;
  n && n.tags && t.push(...n.tags), r && r.tags && t.push(...r.tags);
  const [i, s] = Mo(t, (o) => o.tagLink && o.tagLink.blocked);
  return { blocked: i, selected: s };
}
const Ct = {
  WIDTH: [],
  HEIGHT: [],
  CACHEBUSTER: [() => Date.now()],
  IP: [],
  USER_AGENT: [() => {
    var e;
    return (e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent;
  }],
  DNT: [],
  POD_MAX_DUR: [],
  POD_AD_SLOTS: [],
  APP_BUNDLE: [],
  APP_NAME: [],
  APP_STORE_URL: [],
  CONTENT_ID: [],
  CONTENT_EPISODE: [],
  CONTENT_TITLE: [],
  CONTENT_SERIES: [],
  CONTENT_SEASON: [],
  CHANNEL_NAME: [],
  DEVICE_ID: [],
  CONSENT: [],
  GDPR: [],
  US_PRIVACY: [],
  COPPA: [],
  LMT: [],
  DEVICE_MAKE: [],
  DEVICE_MODEL: [],
  COUNTRY: [],
  IFA_TYPE: [],
  CONTENT_GENRE: [],
  RATING: [],
  LANGUAGE: []
};
function Vo(e, t, n = !0) {
  if (!e)
    throw new Error("replaceMacrosInURL: url is required but was not provided");
  const r = new URL(e);
  for (const [i, s] of r.searchParams.entries()) {
    const o = Jo(s, t, n);
    r.searchParams.set(i, o);
  }
  return r.toString();
}
function Jo(e, t, n = !0) {
  const r = /[${]{2}([^}]*)[$}]{1,2}/gi;
  let i = e, s;
  for (; s = r.exec(e); ) {
    const [o, a] = s, l = Ct[a] ? Ko(
      Ct,
      t,
      /** @type {keyof typeof MACRO_MAP} */
      a
    ) : void 0;
    l !== void 0 ? i = i.replaceAll(o, String(l)) : n || (i = i.replaceAll(o, ""));
  }
  return i;
}
function Ko(e, t, n) {
  const r = e[n];
  if (r)
    for (const i of r) {
      let s;
      if (typeof i == "function" ? s = i(t) : s = i, s !== void 0)
        return s;
    }
}
const Qc = [
  // Aditude
  {
    id: "aditude",
    name: "Aditude",
    defaults: {
      type: "banner",
      size: null,
      _renderSizeOption: "manual",
      "publisher.scriptUrl": "https://dn0qt3r0xannq.cloudfront.net/aditude-etmtGDUepr/demo-longform/prebid-load.js",
      "publisher.slot": "right-1"
    },
    options: {
      scriptUrl: { show: !0, require: !0 },
      slot: { show: !0, require: !0 }
    },
    types: {
      banner: {
        dynamic: !1,
        manual: !1,
        sizes: H
      }
    }
  },
  // Sovrn
  {
    id: "sovrn",
    name: "Sovrn",
    defaults: {
      type: "banner",
      size: null,
      _renderSizeOption: "manual",
      "publisher.scriptUrl": "",
      "publisher.slot": "",
      json: {}
    },
    options: {
      scriptUrl: { show: !0, require: !0 },
      slot: { show: !0, require: !0 },
      jsonEdit: { show: !0, require: !1 }
    },
    types: {
      banner: {
        dynamic: !1,
        manual: !1,
        sizes: H
      }
    }
  },
  // Unruly
  {
    id: "unruly",
    name: "Unruly",
    defaults: {
      type: "banner",
      size: null,
      _renderSizeOption: "dynamic"
    },
    options: {
      domain: { show: !0, require: !0 },
      target: { show: !0, require: !0 },
      id: { show: !0, require: !0 }
    },
    types: {
      banner: {
        dynamic: !0,
        manual: !0,
        sizes: H
      }
    }
  },
  // VAST URL
  {
    id: "vastTag",
    name: "VAST URL",
    defaults: {
      type: "video",
      size: null,
      _renderSizeOption: "manual"
    },
    options: {
      vastUrl: { show: !0, require: !0 }
    },
    types: {
      video: {
        dynamic: !1,
        manual: !0,
        sizes: H
      },
      banner: {
        dynamic: !1,
        manual: !0,
        sizes: H
      }
    }
  },
  // VFR
  {
    id: "vfr",
    name: "VFR",
    defaults: {
      type: "video",
      size: null,
      _renderSizeOption: "manual"
    },
    options: {
      jsonEdit: { show: !0, require: !0 }
    },
    types: {
      video: {
        dynamic: !1,
        manual: !1,
        sizes: [
          { w: 640, h: 480, prefix: "" },
          { w: 1920, h: 1080, prefix: "" }
        ]
      },
      banner: {
        dynamic: !1,
        manual: !1,
        sizes: H
      }
    }
  }
];
let de;
const ko = new Uint8Array(16);
function Yo() {
  if (!de && (de = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !de))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return de(ko);
}
const T = [];
for (let e = 0; e < 256; ++e)
  T.push((e + 256).toString(16).slice(1));
function Xo(e, t = 0) {
  return (T[e[t + 0]] + T[e[t + 1]] + T[e[t + 2]] + T[e[t + 3]] + "-" + T[e[t + 4]] + T[e[t + 5]] + "-" + T[e[t + 6]] + T[e[t + 7]] + "-" + T[e[t + 8]] + T[e[t + 9]] + "-" + T[e[t + 10]] + T[e[t + 11]] + T[e[t + 12]] + T[e[t + 13]] + T[e[t + 14]] + T[e[t + 15]]).toLowerCase();
}
const Qo = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Nt = {
  randomUUID: Qo
};
function R(e, t, n) {
  if (Nt.randomUUID && !t && !e)
    return Nt.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || Yo)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return Xo(r);
}
class ae {
  constructor(t) {
    I(this, "context");
    I(this, "renderResult");
    I(this, "renderStrategy");
    this.context = t.context;
  }
  /**
   * Issue a request to the partner to get an advertisement
   */
  async request() {
    return { id: "", impid: "", price: 0 };
  }
  /**
   * Render an advertisement
   */
  async render(t) {
    var n;
    this.renderResult = (n = this.renderStrategy) == null ? void 0 : n.call(this, t, this.context);
  }
  /**
   * Initiate user sync with the partner
   */
  async userSync() {
  }
  /**
   * After the ad has been rendered, do any post-render processing
   */
  async postRender(t) {
  }
  /**
   * Do any necessary cleanup when the advertisement needs
   * to be unmounted from the DOM
   */
  async destroy(t) {
  }
  /**
   * Show the advertisement
   */
  async show() {
    var t;
    (t = this.renderResult) == null || t.show();
  }
  /**
   * Hide the advertisement
   */
  async hide() {
    var t;
    (t = this.renderResult) == null || t.hide();
  }
}
function Zo(e, t) {
  e.innerHTML = t, Array.from(e.querySelectorAll("script")).forEach((n) => {
    var s;
    if (n == null)
      return;
    const r = document.createElement("script");
    Array.from(n.attributes).forEach((o) => {
      r.setAttribute(o.name, o.value);
    });
    const i = document.createTextNode(n.innerHTML);
    r.appendChild(i), (s = n.parentNode) == null || s.replaceChild(r, n);
  });
}
function un(e, t) {
  const { element: n } = t, r = e.adm || "", i = document.createElement("div");
  return t.container = i, e.w && (i.style.width = e.w + "px"), e.h && (i.style.height = e.h + "px"), i.style.border = "none", i.style.overflow = "hidden", i.style.transition = "max-height 1s", t.hideUntilReady && (i.style.maxHeight = "0"), Zo(i, r), n.appendChild(i), {
    remove() {
      n.removeChild(i);
    },
    hide() {
      i.style.maxHeight = "0";
    },
    show() {
      i.style.maxHeight = "1000px";
    }
  };
}
const ea = 3e4, L = /* @__PURE__ */ new Map();
async function ta() {
  return new Promise((e, t) => {
    const n = window.googletag = window.googletag || { cmd: [] }, r = setTimeout(() => t(new Error("GoogleTagStrategy::waitUntilLoaded timed out")), ea);
    n.cmd.push(() => {
      clearTimeout(r), e(n);
    });
  });
}
async function na(e, t, n) {
  await ta();
  const r = { slotElementId: t, callback: n, uuid: R() };
  return L.has(e) || (L.set(e, []), googletag.pubads().addEventListener(e, (i) => {
    var o, a;
    const s = (o = i.slot) == null ? void 0 : o.getSlotElementId();
    (a = L.get(e)) == null || a.forEach(({ slotElementId: l, callback: c }) => {
      s === l && c(i);
    });
  })), L.get(e).push(r), () => {
    ra(e, r);
  };
}
function ra(e, t) {
  const n = L.get(e) ?? [];
  t == null ? L.delete(e) : t.uuid != null ? L.set(e, n.filter((r) => r.uuid !== t.uuid)) : t.slotElementId != null ? L.set(e, n.filter((r) => r.slotElementId !== t.slotElementId)) : L.set(e, n.filter((r) => r.callback !== t.callback));
}
async function ia(e, t) {
  let n;
  return new Promise((r, i) => {
    na(e, t, (s) => {
      n != null && n(), r(s);
    }).catch(i).then((s) => {
      n = s;
    });
  });
}
async function sa(e) {
  if ((await ia("slotRenderEnded", e)).isEmpty)
    throw new z("GoogleTagStrategy::waitForSlotRenderEnded failed, isEmpty is true", Vt);
}
function ln(e) {
  const t = () => () => {
  };
  return {
    debug: t(),
    error: t(),
    info: t(),
    warn: t(),
    child: (n) => ln()
  };
}
const oa = ln(), aa = 3e4, Lt = /* @__PURE__ */ new Set();
class ca extends ae {
  /**
   * Creates an instance of PartnerStrategy.
   */
  constructor(n) {
    super(n);
    I(this, "context");
    I(this, "divId");
    I(this, "renderStrategy", un);
    this.context = n.context;
  }
  /**
   *
   */
  async loadScriptOnce(n) {
    if (!Lt.has(n))
      return await new Promise((r, i) => {
        Lt.add(n);
        const s = document.getElementsByTagName("head")[0], o = document.createElement("script");
        o.src = n, o.addEventListener("load", () => r()), o.addEventListener("error", () => i()), s.appendChild(o);
      });
  }
  /**
   *
   */
  async waitUntilLoaded() {
    return new Promise((n, r) => {
      tude = window.tude = window.tude || { cmd: [] };
      const i = setTimeout(() => r(new Error("AditudeStrategy::waitUntilLoaded timed out")), aa);
      tude.cmd.push(() => {
        clearTimeout(i), n();
      });
    });
  }
  /**
   *
   */
  async request() {
    await this.loadScriptOnce(this.context.publisher.scriptUrl || ""), await this.waitUntilLoaded();
    const n = R();
    return {
      id: n,
      impid: R(),
      price: null,
      adm: `<div id="${n}"></div>`
    };
  }
  /**
   *
   */
  async postRender(n) {
    const r = this.context.publisher.slot || "", i = r.startsWith("pb-slot-") ? r : `pb-slot-${r}`;
    tude.refreshAdsViaDivMappings([{
      divId: n.id,
      baseDivId: i,
      //I think these are just whatever key/value pairs we want, so we can stuff whatever
      //we want here
      targeting: {
        //we might want to do this differently, and provide keys for each IAB category
        //and set them to blocked or targeted or something, so that those can be targeted
        //in GAM or Aditude
        bcat: (this.context.bcat || []).join(","),
        cat: (this.context.cat || []).join(",")
      }
    }]);
    try {
      await sa(n.id), oa.debug("AditudeStrategy::postRender: slot render success");
    } catch (s) {
      throw this.destroy(n), s;
    }
  }
}
function dn(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: ua } = Object.prototype, { getPrototypeOf: Ze } = Object, we = ((e) => (t) => {
  const n = ua.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), N = (e) => (e = e.toLowerCase(), (t) => we(t) === e), Ee = (e) => (t) => typeof t === e, { isArray: X } = Array, se = Ee("undefined");
function la(e) {
  return e !== null && !se(e) && e.constructor !== null && !se(e.constructor) && x(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const fn = N("ArrayBuffer");
function da(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && fn(e.buffer), t;
}
const fa = Ee("string"), x = Ee("function"), pn = Ee("number"), Ae = (e) => e !== null && typeof e == "object", pa = (e) => e === !0 || e === !1, fe = (e) => {
  if (we(e) !== "object")
    return !1;
  const t = Ze(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, ha = N("Date"), ma = N("File"), ya = N("Blob"), ga = N("FileList"), ba = (e) => Ae(e) && x(e.pipe), wa = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || x(e.append) && ((t = we(e)) === "formdata" || // detect form-data instance
  t === "object" && x(e.toString) && e.toString() === "[object FormData]"));
}, Ea = N("URLSearchParams"), Aa = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ce(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), X(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = s.length;
    let a;
    for (r = 0; r < o; r++)
      a = s[r], t.call(null, e[a], a, e);
  }
}
function hn(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const mn = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), yn = (e) => !se(e) && e !== mn;
function Me() {
  const { caseless: e } = yn(this) && this || {}, t = {}, n = (r, i) => {
    const s = e && hn(t, i) || i;
    fe(t[s]) && fe(r) ? t[s] = Me(t[s], r) : fe(r) ? t[s] = Me({}, r) : X(r) ? t[s] = r.slice() : t[s] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && ce(arguments[r], n);
  return t;
}
const _a = (e, t, n, { allOwnKeys: r } = {}) => (ce(t, (i, s) => {
  n && x(i) ? e[s] = dn(i, n) : e[s] = i;
}, { allOwnKeys: r }), e), Sa = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ta = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Ia = (e, t, n, r) => {
  let i, s, o;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), s = i.length; s-- > 0; )
      o = i[s], (!r || r(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = n !== !1 && Ze(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Oa = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, xa = (e) => {
  if (!e)
    return null;
  if (X(e))
    return e;
  let t = e.length;
  if (!pn(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Ra = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ze(Uint8Array)), va = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const s = i.value;
    t.call(e, s[0], s[1]);
  }
}, Pa = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Ca = N("HTMLFormElement"), Na = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), Bt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), La = N("RegExp"), gn = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  ce(n, (i, s) => {
    t(i, s, e) !== !1 && (r[s] = i);
  }), Object.defineProperties(e, r);
}, Ba = (e) => {
  gn(e, (t, n) => {
    if (x(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (x(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Da = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((s) => {
      n[s] = !0;
    });
  };
  return X(e) ? r(e) : r(String(e).split(t)), n;
}, Ua = () => {
}, $a = (e, t) => (e = +e, Number.isFinite(e) ? e : t), ve = "abcdefghijklmnopqrstuvwxyz", Dt = "0123456789", bn = {
  DIGIT: Dt,
  ALPHA: ve,
  ALPHA_DIGIT: ve + ve.toUpperCase() + Dt
}, Ma = (e = 16, t = bn.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function Fa(e) {
  return !!(e && x(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const ja = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (Ae(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const s = X(r) ? [] : {};
        return ce(r, (o, a) => {
          const l = n(o, i + 1);
          !se(l) && (s[a] = l);
        }), t[i] = void 0, s;
      }
    }
    return r;
  };
  return n(e, 0);
}, Ha = N("AsyncFunction"), qa = (e) => e && (Ae(e) || x(e)) && x(e.then) && x(e.catch), u = {
  isArray: X,
  isArrayBuffer: fn,
  isBuffer: la,
  isFormData: wa,
  isArrayBufferView: da,
  isString: fa,
  isNumber: pn,
  isBoolean: pa,
  isObject: Ae,
  isPlainObject: fe,
  isUndefined: se,
  isDate: ha,
  isFile: ma,
  isBlob: ya,
  isRegExp: La,
  isFunction: x,
  isStream: ba,
  isURLSearchParams: Ea,
  isTypedArray: Ra,
  isFileList: ga,
  forEach: ce,
  merge: Me,
  extend: _a,
  trim: Aa,
  stripBOM: Sa,
  inherits: Ta,
  toFlatObject: Ia,
  kindOf: we,
  kindOfTest: N,
  endsWith: Oa,
  toArray: xa,
  forEachEntry: va,
  matchAll: Pa,
  isHTMLForm: Ca,
  hasOwnProperty: Bt,
  hasOwnProp: Bt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: gn,
  freezeMethods: Ba,
  toObjectSet: Da,
  toCamelCase: Na,
  noop: Ua,
  toFiniteNumber: $a,
  findKey: hn,
  global: mn,
  isContextDefined: yn,
  ALPHABET: bn,
  generateString: Ma,
  isSpecCompliantForm: Fa,
  toJSONObject: ja,
  isAsyncFn: Ha,
  isThenable: qa
};
function g(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
u.inherits(g, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: u.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const wn = g.prototype, En = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  En[e] = { value: e };
});
Object.defineProperties(g, En);
Object.defineProperty(wn, "isAxiosError", { value: !0 });
g.from = (e, t, n, r, i, s) => {
  const o = Object.create(wn);
  return u.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), g.call(o, e.message, t, n, r, i), o.cause = e, o.name = e.name, s && Object.assign(o, s), o;
};
const za = null;
function Fe(e) {
  return u.isPlainObject(e) || u.isArray(e);
}
function An(e) {
  return u.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ut(e, t, n) {
  return e ? e.concat(t).map(function(i, s) {
    return i = An(i), !n && s ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function Ga(e) {
  return u.isArray(e) && !e.some(Fe);
}
const Wa = u.toFlatObject(u, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function _e(e, t, n) {
  if (!u.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = u.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, A) {
    return !u.isUndefined(A[h]);
  });
  const r = n.metaTokens, i = n.visitor || d, s = n.dots, o = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && u.isSpecCompliantForm(t);
  if (!u.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(f) {
    if (f === null)
      return "";
    if (u.isDate(f))
      return f.toISOString();
    if (!l && u.isBlob(f))
      throw new g("Blob is not supported. Use a Buffer instead.");
    return u.isArrayBuffer(f) || u.isTypedArray(f) ? l && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function d(f, h, A) {
    let E = f;
    if (f && !A && typeof f == "object") {
      if (u.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (u.isArray(f) && Ga(f) || (u.isFileList(f) || u.endsWith(h, "[]")) && (E = u.toArray(f)))
        return h = An(h), E.forEach(function(S, O) {
          !(u.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Ut([h], O, s) : o === null ? h : h + "[]",
            c(S)
          );
        }), !1;
    }
    return Fe(f) ? !0 : (t.append(Ut(A, h, s), c(f)), !1);
  }
  const p = [], m = Object.assign(Wa, {
    defaultVisitor: d,
    convertValue: c,
    isVisitable: Fe
  });
  function y(f, h) {
    if (!u.isUndefined(f)) {
      if (p.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      p.push(f), u.forEach(f, function(E, b) {
        (!(u.isUndefined(E) || E === null) && i.call(
          t,
          E,
          u.isString(b) ? b.trim() : b,
          h,
          m
        )) === !0 && y(E, h ? h.concat(b) : [b]);
      }), p.pop();
    }
  }
  if (!u.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function $t(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function et(e, t) {
  this._pairs = [], e && _e(e, this, t);
}
const _n = et.prototype;
_n.append = function(t, n) {
  this._pairs.push([t, n]);
};
_n.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, $t);
  } : $t;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function Va(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Sn(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Va, i = n && n.serialize;
  let s;
  if (i ? s = i(t, n) : s = u.isURLSearchParams(t) ? t.toString() : new et(t, n).toString(r), s) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Ja {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    u.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Mt = Ja, Tn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ka = typeof URLSearchParams < "u" ? URLSearchParams : et, ka = typeof FormData < "u" ? FormData : null, Ya = typeof Blob < "u" ? Blob : null, Xa = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Qa = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), P = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ka,
    FormData: ka,
    Blob: Ya
  },
  isStandardBrowserEnv: Xa,
  isStandardBrowserWebWorkerEnv: Qa,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Za(e, t) {
  return _e(e, new P.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, s) {
      return P.isNode && u.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function ec(e) {
  return u.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function tc(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let s;
  for (r = 0; r < i; r++)
    s = n[r], t[s] = e[s];
  return t;
}
function In(e) {
  function t(n, r, i, s) {
    let o = n[s++];
    const a = Number.isFinite(+o), l = s >= n.length;
    return o = !o && u.isArray(i) ? i.length : o, l ? (u.hasOwnProp(i, o) ? i[o] = [i[o], r] : i[o] = r, !a) : ((!i[o] || !u.isObject(i[o])) && (i[o] = []), t(n, r, i[o], s) && u.isArray(i[o]) && (i[o] = tc(i[o])), !a);
  }
  if (u.isFormData(e) && u.isFunction(e.entries)) {
    const n = {};
    return u.forEachEntry(e, (r, i) => {
      t(ec(r), i, n, 0);
    }), n;
  }
  return null;
}
const nc = {
  "Content-Type": void 0
};
function rc(e, t, n) {
  if (u.isString(e))
    try {
      return (t || JSON.parse)(e), u.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Se = {
  transitional: Tn,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, s = u.isObject(t);
    if (s && u.isHTMLForm(t) && (t = new FormData(t)), u.isFormData(t))
      return i && i ? JSON.stringify(In(t)) : t;
    if (u.isArrayBuffer(t) || u.isBuffer(t) || u.isStream(t) || u.isFile(t) || u.isBlob(t))
      return t;
    if (u.isArrayBufferView(t))
      return t.buffer;
    if (u.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Za(t, this.formSerializer).toString();
      if ((a = u.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return _e(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return s || i ? (n.setContentType("application/json", !1), rc(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Se.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (t && u.isString(t) && (r && !this.responseType || i)) {
      const o = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? g.from(a, g.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: P.classes.FormData,
    Blob: P.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
u.forEach(["delete", "get", "head"], function(t) {
  Se.headers[t] = {};
});
u.forEach(["post", "put", "patch"], function(t) {
  Se.headers[t] = u.merge(nc);
});
const tt = Se, ic = u.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), sc = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), n = o.substring(0, i).trim().toLowerCase(), r = o.substring(i + 1).trim(), !(!n || t[n] && ic[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ft = Symbol("internals");
function Z(e) {
  return e && String(e).trim().toLowerCase();
}
function pe(e) {
  return e === !1 || e == null ? e : u.isArray(e) ? e.map(pe) : String(e);
}
function oc(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const ac = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Pe(e, t, n, r, i) {
  if (u.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!u.isString(t)) {
    if (u.isString(r))
      return t.indexOf(r) !== -1;
    if (u.isRegExp(r))
      return r.test(t);
  }
}
function cc(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function uc(e, t) {
  const n = u.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, s, o) {
        return this[r].call(this, t, i, s, o);
      },
      configurable: !0
    });
  });
}
class Te {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function s(a, l, c) {
      const d = Z(l);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const p = u.findKey(i, d);
      (!p || i[p] === void 0 || c === !0 || c === void 0 && i[p] !== !1) && (i[p || l] = pe(a));
    }
    const o = (a, l) => u.forEach(a, (c, d) => s(c, d, l));
    return u.isPlainObject(t) || t instanceof this.constructor ? o(t, n) : u.isString(t) && (t = t.trim()) && !ac(t) ? o(sc(t), n) : t != null && s(n, t, r), this;
  }
  get(t, n) {
    if (t = Z(t), t) {
      const r = u.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return oc(i);
        if (u.isFunction(n))
          return n.call(this, i, r);
        if (u.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Z(t), t) {
      const r = u.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Pe(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function s(o) {
      if (o = Z(o), o) {
        const a = u.findKey(r, o);
        a && (!n || Pe(r, r[a], a, n)) && (delete r[a], i = !0);
      }
    }
    return u.isArray(t) ? t.forEach(s) : s(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const s = n[r];
      (!t || Pe(this, this[s], s, t, !0)) && (delete this[s], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return u.forEach(this, (i, s) => {
      const o = u.findKey(r, s);
      if (o) {
        n[o] = pe(i), delete n[s];
        return;
      }
      const a = t ? cc(s) : String(s).trim();
      a !== s && delete n[s], n[a] = pe(i), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return u.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && u.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[Ft] = this[Ft] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function s(o) {
      const a = Z(o);
      r[a] || (uc(i, o), r[a] = !0);
    }
    return u.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
Te.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
u.freezeMethods(Te.prototype);
u.freezeMethods(Te);
const D = Te;
function Ce(e, t) {
  const n = this || tt, r = t || n, i = D.from(r.headers);
  let s = r.data;
  return u.forEach(e, function(a) {
    s = a.call(n, s, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), s;
}
function On(e) {
  return !!(e && e.__CANCEL__);
}
function ue(e, t, n) {
  g.call(this, e ?? "canceled", g.ERR_CANCELED, t, n), this.name = "CanceledError";
}
u.inherits(ue, g, {
  __CANCEL__: !0
});
function lc(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new g(
    "Request failed with status code " + n.status,
    [g.ERR_BAD_REQUEST, g.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const dc = P.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, i, s, o, a) {
        const l = [];
        l.push(n + "=" + encodeURIComponent(r)), u.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), u.isString(s) && l.push("path=" + s), u.isString(o) && l.push("domain=" + o), a === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function fc(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function pc(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function xn(e, t) {
  return e && !fc(t) ? pc(e, t) : t;
}
const hc = P.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(s) {
      let o = s;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(o) {
      const a = u.isString(o) ? i(o) : o;
      return a.protocol === r.protocol && a.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function mc(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function yc(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, s = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), d = r[s];
    o || (o = c), n[i] = l, r[i] = c;
    let p = s, m = 0;
    for (; p !== i; )
      m += n[p++], p = p % e;
    if (i = (i + 1) % e, i === s && (s = (s + 1) % e), c - o < t)
      return;
    const y = d && c - d;
    return y ? Math.round(m * 1e3 / y) : void 0;
  };
}
function jt(e, t) {
  let n = 0;
  const r = yc(50, 250);
  return (i) => {
    const s = i.loaded, o = i.lengthComputable ? i.total : void 0, a = s - n, l = r(a), c = s <= o;
    n = s;
    const d = {
      loaded: s,
      total: o,
      progress: o ? s / o : void 0,
      bytes: a,
      rate: l || void 0,
      estimated: l && o && c ? (o - s) / l : void 0,
      event: i
    };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
const gc = typeof XMLHttpRequest < "u", bc = gc && function(e) {
  return new Promise(function(n, r) {
    let i = e.data;
    const s = D.from(e.headers).normalize(), o = e.responseType;
    let a;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(a), e.signal && e.signal.removeEventListener("abort", a);
    }
    u.isFormData(i) && (P.isStandardBrowserEnv || P.isStandardBrowserWebWorkerEnv ? s.setContentType(!1) : s.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const y = e.auth.username || "", f = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(y + ":" + f));
    }
    const d = xn(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), Sn(d, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function p() {
      if (!c)
        return;
      const y = D.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), h = {
        data: !o || o === "text" || o === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: y,
        config: e,
        request: c
      };
      lc(function(E) {
        n(E), l();
      }, function(E) {
        r(E), l();
      }, h), c = null;
    }
    if ("onloadend" in c ? c.onloadend = p : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(p);
    }, c.onabort = function() {
      c && (r(new g("Request aborted", g.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      r(new g("Network Error", g.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let f = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const h = e.transitional || Tn;
      e.timeoutErrorMessage && (f = e.timeoutErrorMessage), r(new g(
        f,
        h.clarifyTimeoutError ? g.ETIMEDOUT : g.ECONNABORTED,
        e,
        c
      )), c = null;
    }, P.isStandardBrowserEnv) {
      const y = (e.withCredentials || hc(d)) && e.xsrfCookieName && dc.read(e.xsrfCookieName);
      y && s.set(e.xsrfHeaderName, y);
    }
    i === void 0 && s.setContentType(null), "setRequestHeader" in c && u.forEach(s.toJSON(), function(f, h) {
      c.setRequestHeader(h, f);
    }), u.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), o && o !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", jt(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", jt(e.onUploadProgress)), (e.cancelToken || e.signal) && (a = (y) => {
      c && (r(!y || y.type ? new ue(null, e, c) : y), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(a), e.signal && (e.signal.aborted ? a() : e.signal.addEventListener("abort", a)));
    const m = mc(d);
    if (m && P.protocols.indexOf(m) === -1) {
      r(new g("Unsupported protocol " + m + ":", g.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(i || null);
  });
}, he = {
  http: za,
  xhr: bc
};
u.forEach(he, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const wc = {
  getAdapter: (e) => {
    e = u.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let i = 0; i < t && (n = e[i], !(r = u.isString(n) ? he[n.toLowerCase()] : n)); i++)
      ;
    if (!r)
      throw r === !1 ? new g(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        u.hasOwnProp(he, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!u.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: he
};
function Ne(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ue(null, e);
}
function Ht(e) {
  return Ne(e), e.headers = D.from(e.headers), e.data = Ce.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), wc.getAdapter(e.adapter || tt.adapter)(e).then(function(r) {
    return Ne(e), r.data = Ce.call(
      e,
      e.transformResponse,
      r
    ), r.headers = D.from(r.headers), r;
  }, function(r) {
    return On(r) || (Ne(e), r && r.response && (r.response.data = Ce.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = D.from(r.response.headers))), Promise.reject(r);
  });
}
const qt = (e) => e instanceof D ? e.toJSON() : e;
function k(e, t) {
  t = t || {};
  const n = {};
  function r(c, d, p) {
    return u.isPlainObject(c) && u.isPlainObject(d) ? u.merge.call({ caseless: p }, c, d) : u.isPlainObject(d) ? u.merge({}, d) : u.isArray(d) ? d.slice() : d;
  }
  function i(c, d, p) {
    if (u.isUndefined(d)) {
      if (!u.isUndefined(c))
        return r(void 0, c, p);
    } else
      return r(c, d, p);
  }
  function s(c, d) {
    if (!u.isUndefined(d))
      return r(void 0, d);
  }
  function o(c, d) {
    if (u.isUndefined(d)) {
      if (!u.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, d);
  }
  function a(c, d, p) {
    if (p in t)
      return r(c, d);
    if (p in e)
      return r(void 0, c);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (c, d) => i(qt(c), qt(d), !0)
  };
  return u.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const p = l[d] || i, m = p(e[d], t[d], d);
    u.isUndefined(m) && p !== a || (n[d] = m);
  }), n;
}
const Rn = "1.4.0", nt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  nt[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const zt = {};
nt.transitional = function(t, n, r) {
  function i(s, o) {
    return "[Axios v" + Rn + "] Transitional option '" + s + "'" + o + (r ? ". " + r : "");
  }
  return (s, o, a) => {
    if (t === !1)
      throw new g(
        i(o, " has been removed" + (n ? " in " + n : "")),
        g.ERR_DEPRECATED
      );
    return n && !zt[o] && (zt[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, o, a) : !0;
  };
};
function Ec(e, t, n) {
  if (typeof e != "object")
    throw new g("options must be an object", g.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const s = r[i], o = t[s];
    if (o) {
      const a = e[s], l = a === void 0 || o(a, s, e);
      if (l !== !0)
        throw new g("option " + s + " must be " + l, g.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new g("Unknown option " + s, g.ERR_BAD_OPTION);
  }
}
const je = {
  assertOptions: Ec,
  validators: nt
}, F = je.validators;
class ye {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Mt(),
      response: new Mt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = k(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: s } = n;
    r !== void 0 && je.assertOptions(r, {
      silentJSONParsing: F.transitional(F.boolean),
      forcedJSONParsing: F.transitional(F.boolean),
      clarifyTimeoutError: F.transitional(F.boolean)
    }, !1), i != null && (u.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : je.assertOptions(i, {
      encode: F.function,
      serialize: F.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o;
    o = s && u.merge(
      s.common,
      s[n.method]
    ), o && u.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete s[f];
      }
    ), n.headers = D.concat(o, s);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(n) === !1 || (l = l && h.synchronous, a.unshift(h.fulfilled, h.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(h) {
      c.push(h.fulfilled, h.rejected);
    });
    let d, p = 0, m;
    if (!l) {
      const f = [Ht.bind(this), void 0];
      for (f.unshift.apply(f, a), f.push.apply(f, c), m = f.length, d = Promise.resolve(n); p < m; )
        d = d.then(f[p++], f[p++]);
      return d;
    }
    m = a.length;
    let y = n;
    for (p = 0; p < m; ) {
      const f = a[p++], h = a[p++];
      try {
        y = f(y);
      } catch (A) {
        h.call(this, A);
        break;
      }
    }
    try {
      d = Ht.call(this, y);
    } catch (f) {
      return Promise.reject(f);
    }
    for (p = 0, m = c.length; p < m; )
      d = d.then(c[p++], c[p++]);
    return d;
  }
  getUri(t) {
    t = k(this.defaults, t);
    const n = xn(t.baseURL, t.url);
    return Sn(n, t.params, t.paramsSerializer);
  }
}
u.forEach(["delete", "get", "head", "options"], function(t) {
  ye.prototype[t] = function(n, r) {
    return this.request(k(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
u.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(s, o, a) {
      return this.request(k(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: o
      }));
    };
  }
  ye.prototype[t] = n(), ye.prototype[t + "Form"] = n(!0);
});
const me = ye;
class rt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let s;
      const o = new Promise((a) => {
        r.subscribe(a), s = a;
      }).then(i);
      return o.cancel = function() {
        r.unsubscribe(s);
      }, o;
    }, t(function(s, o, a) {
      r.reason || (r.reason = new ue(s, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new rt(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
const Ac = rt;
function _c(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Sc(e) {
  return u.isObject(e) && e.isAxiosError === !0;
}
const He = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(He).forEach(([e, t]) => {
  He[t] = e;
});
const Tc = He;
function vn(e) {
  const t = new me(e), n = dn(me.prototype.request, t);
  return u.extend(n, me.prototype, t, { allOwnKeys: !0 }), u.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return vn(k(e, i));
  }, n;
}
const _ = vn(tt);
_.Axios = me;
_.CanceledError = ue;
_.CancelToken = Ac;
_.isCancel = On;
_.VERSION = Rn;
_.toFormData = _e;
_.AxiosError = g;
_.Cancel = _.CanceledError;
_.all = function(t) {
  return Promise.all(t);
};
_.spread = _c;
_.isAxiosError = Sc;
_.mergeConfig = k;
_.AxiosHeaders = D;
_.formToJSON = (e) => In(u.isHTMLForm(e) ? new FormData(e) : e);
_.HttpStatusCode = Tc;
_.default = _;
const Ic = _;
function qe(e) {
  const t = new URL(e);
  t.searchParams.set(R(), Date.now().toString());
  const n = document.createElement("img");
  n.src = t.toString(), n.style.display = "none";
  const r = new Promise((i, s) => {
    n.addEventListener("load", () => {
      i(), n.remove();
    }), n.addEventListener("error", ({ error: o }) => {
      console.error("Error occurred while sending beacon", o, e), s(o), n.remove();
    });
  });
  return document.body.appendChild(n), r;
}
function Zc(e, t) {
  e && e.forEach((n) => {
    qe(t ? t.appendIdToPixel(n) : n);
  });
}
const Oc = (e) => `
<html>
    <head>
        <style>
            body,html{margin:0;padding:0;overflow:hidden;background-color:transparent;width:100%;height:100%}
        </style>
    </head>
<body>
    ${e}
</body>
</html>`;
function it(e, t) {
  const { element: n } = t, r = Oc(e.adm || ""), i = document.createElement("iframe");
  return t.container = i, i.style.width = e.w + "px", i.style.height = e.h + "px", i.style.border = "none", i.style.overflow = "hidden", i.allowtransparency = !0, "srcdoc" in i ? i.srcdoc = r : i.src = "data:text/html;charset=utf-8," + encodeURI(r), n == null || n.appendChild(i), {
    remove() {
      n.removeChild(i);
    },
    hide() {
      i.style.display = "none";
    },
    show() {
      i.style.display = "inline-block";
    }
  };
}
const xc = "https://rtb.sourcesync.io", Rc = "https://rtb.sourcesync.io?f=usi";
let Gt = !1;
const vc = {
  headers: { "content-type": "application/json", "x-openrtb-version": 2.5 },
  //this is needed to include the oRTB uid cookies
  withCredentials: !0
};
class Pc extends ae {
  /**
   * Creates an instance of PartnerStrategy.
   *
   */
  constructor(n) {
    super(n);
    I(this, "context");
    I(this, "renderStrategy", it);
    this.context = n.context;
  }
  /**
   *
   */
  async request() {
    const { bannerFormats: n, publisher: r, cat: i, bcat: s } = this.context, o = (n || []).map((c) => ({ w: c.w, h: c.h })), a = {
      id: R(),
      bcat: s,
      imp: [
        {
          id: R(),
          banner: {
            format: o,
            pos: 1,
            mimes: [
              "application/javascript",
              "text/html",
              "image/gif",
              "image/jpg"
            ]
          },
          secure: 1
        }
      ],
      site: {
        id: r.id,
        domain: r.domain,
        page: r.target,
        cat: i
      },
      at: 1,
      device: {
        ua: navigator.userAgent,
        js: 1
      }
    }, { data: l } = await Ic.post(xc, JSON.stringify(a), vc);
    if (!l || Object.keys(l).length === 0 || De(l, "seatbid").length === 0)
      throw new z("Advertisement was not able to load...", Vt);
    return De(l, "seatbid[0].bid[0]");
  }
  /**
   *
   */
  async userSync() {
    if (!Gt)
      try {
        await qe(Rc);
      } catch {
      } finally {
        Gt = !0;
      }
  }
}
const Cc = 3e4, Wt = /* @__PURE__ */ new Set();
class Nc extends ae {
  /**
   * Creates an instance of PartnerStrategy.
   */
  constructor(n) {
    super(n);
    I(this, "context");
    I(this, "renderStrategy", un);
    this.context = n.context;
  }
  /**
   *
   */
  async loadScriptOnce(n) {
    if (!Wt.has(n))
      return await new Promise((r, i) => {
        Wt.add(n);
        const s = document.getElementsByTagName("head")[0], o = document.createElement("script");
        o.src = n, o.addEventListener("load", () => r()), o.addEventListener("error", () => i()), s.appendChild(o);
      });
  }
  /**
   *
   */
  async waitUntilLoaded() {
    return new Promise((n, r) => {
      window.propertag = window.propertag || { cmd: [] };
      const i = setTimeout(() => r(new Error("SovrnStrategy::waitUntilLoaded timed out")), Cc);
      propertag.cmd.push(() => {
        clearTimeout(i), n();
      });
    });
  }
  /**
   *
   */
  async request() {
    const { publisher: n, json: r, cat: i } = this.context, s = window.properSpecialOps = window.properSpecialOps || {};
    s.spa_settings = {
      enabled: !0
    }, s.page_meta = s.page_meta || {}, s.page_meta.tags = i;
    for (const [a, l] of Object.entries(r || {}))
      Fo(s, a, l);
    return await this.loadScriptOnce(n.scriptUrl || ""), await this.waitUntilLoaded(), {
      id: R(),
      impid: R(),
      price: null,
      adm: `<div id="proper-ad-${n.slot}"></div>`
    };
  }
  /**
   *
   */
  async postRender(n) {
    properBuildSlots();
  }
  /**
   * Do any necessary cleanup when the advertisement needs
   * to be unmounted from the DOM
   */
  async destroy(n) {
    var r;
    properDeleteSlot(this.context.publisher.slot), (r = this.context.container) == null || r.remove();
  }
}
const Lc = 640, Bc = 360;
class Dc extends ae {
  /**
   * Creates an instance of PartnerStrategy.
   */
  constructor(n) {
    super(n);
    I(this, "context");
    I(this, "renderStrategy", it);
    this.context = n.context;
  }
  /**
   *
   */
  async request() {
    var i, s;
    const { bannerFormats: n } = this.context;
    return {
      id: R(),
      impid: R(),
      // @ts-expect-error price is not allowed to be null
      // but we make it null because we don't want to say this was 0
      // because that would be a lie
      price: null,
      adm: `<script type="text/javascript" src="//imasdk.googleapis.com/js/sdkloader/ima3_debug.js"><\/script>
            <video style="display:none;" muted id="mediaElement">
                <source src="https://www.w3schools.com/html/mov_bbb.mp4"></source>
            </video>
            <div id="adContainer"></div>
            <style>
            #adContainer {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
            </style>
            `,
      w: ((i = n == null ? void 0 : n[0]) == null ? void 0 : i.w) || Lc,
      h: ((s = n == null ? void 0 : n[0]) == null ? void 0 : s.h) || Bc
    };
  }
  /**
   *
   */
  async postRender(n) {
    const r = this.context, i = Vo(r.publisher.vastUrl || "", r, !0), s = r.container;
    let o;
    s.addEventListener("load", () => {
      var A, E;
      const a = (A = s.contentWindow) == null ? void 0 : A.document.getElementById("adContainer"), l = (E = s.contentWindow) == null ? void 0 : E.document.getElementById("mediaElement");
      typeof s.contentWindow.google < "u" && c(s.contentWindow.google);
      function c(b) {
        const S = new b.ima.AdDisplayContainer(a, l), O = new b.ima.AdsLoader(S);
        O.addEventListener(b.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, d, !1);
        const v = new b.ima.AdsRequest();
        v.adTagUrl = i, O.requestAds(v), S.initialize();
      }
      function d(b) {
        var O, v, ot, at;
        const S = s.contentWindow.google;
        o = b.getAdsManager(l), o.init((v = (O = r == null ? void 0 : r.bannerFormats) == null ? void 0 : O[0]) == null ? void 0 : v.w, (at = (ot = r == null ? void 0 : r.bannerFormats) == null ? void 0 : ot[0]) == null ? void 0 : at.h, S.ima.ViewMode.NORMAL), o.start(), o.setVolume(0), o.addEventListener(S.ima.AdEvent.Type.COMPLETE, p), o.addEventListener(S.ima.AdEvent.Type.CLICK, m), o.addEventListener(S.ima.AdEvent.Type.PAUSED, y), o.addEventListener(S.ima.AdEvent.Type.STARTED, f), o.addEventListener(S.ima.AdEvent.Type.LOADED, h);
      }
      function p(b) {
      }
      function m(b) {
      }
      function y(b) {
      }
      function f(b) {
      }
      function h(b) {
      }
    });
  }
}
const Uc = 640, $c = 360;
class Mc extends ae {
  /**
   * Creates an instance of VfrStrategy.
   */
  constructor(n) {
    super(n);
    I(this, "context");
    I(this, "renderStrategy", it);
    this.context = n.context;
  }
  /**
   *
   */
  async request() {
    var a, l;
    const { json: n = {}, bannerFormats: r = [] } = this.context, i = n.playerWidth ?? ((a = r == null ? void 0 : r[0]) == null ? void 0 : a.w) ?? Uc, s = n.playerHeight ?? ((l = r == null ? void 0 : r[0]) == null ? void 0 : l.h) ?? $c;
    return {
      id: R(),
      impid: R(),
      // @ts-ignore
      price: null,
      adm: '<script src="https://qa.vfrsdk.com/monetize_sdk_script.js"><\/script>',
      w: i,
      h: s
    };
  }
  /**
   *
   */
  async postRender(n) {
    const r = this.context, i = r.container;
    i == null || i.addEventListener("load", () => {
      const s = i.contentWindow.monSdkManager;
      s.initAdPolling({
        onSdkInitializedCb: () => {
          s.enableShowAds(!0);
        },
        macros: r.json
      });
    });
  }
}
const Fc = {
  aditude: ca,
  sovrn: Nc,
  unruly: Pc,
  vastTag: Dc,
  vfr: Mc
}, jc = new Map(Object.entries(Fc));
function Hc(e, t = {}) {
  const n = e.getBoundingClientRect(), r = window.scrollX || document.documentElement.scrollLeft, i = window.scrollY || document.documentElement.scrollTop, s = {
    right: n.right + (t.right && n.width < 5 ? t.right : 0) + r,
    left: n.left + (t.left && n.width < 5 ? t.left : 0) + r,
    top: n.top + (t.top && n.height < 5 ? t.top : 0) + i,
    bottom: n.bottom + (t.bottom && n.height < 5 ? t.bottom : 0) + i,
    width: 0,
    height: 0
  };
  s.width = s.right - s.left, s.height = s.bottom - s.top;
  const o = window.innerWidth || document.documentElement.clientWidth, a = window.innerHeight || document.documentElement.clientHeight, l = {
    x: Math.max(0, Math.min(s.right, o + r) - Math.max(s.left, r)),
    y: Math.max(0, Math.min(s.bottom, a + i) - Math.max(s.top, i))
  }, c = {
    x: l.x / s.width,
    y: l.y / s.height
  }, d = l.x === s.width && l.y === s.height;
  return { isInViewport: l.x > 0 && l.y > 0, isFullyInViewport: d, percentageInViewport: c, pixelsInViewport: l };
}
async function eu(e) {
  const {
    bannerFormats: t,
    partner: n
  } = e;
  qc(e);
  const r = jc.get(n || "");
  if (!r)
    throw new z(`Could not load strategy for partner: ${n}`, Dn);
  const i = new r({ context: e });
  await i.userSync();
  const s = await i.request(), o = s && s.adm || "";
  return o && (await i.render(s), await i.postRender(s), e.hideUntilReady && i.show()), {
    content: o,
    storedBannerSizes: t,
    currentBannerSize: { w: s.w, h: s.h },
    destroy: () => i.destroy(s)
  };
}
function qc(e) {
  if (e == null)
    throw new z("No context provided", Ie);
  if (e.partner == null)
    throw new z("No partner provided", Ie);
  if (e.element == null)
    throw new z("No element provided", Ie);
  if (e.requireInViewport === !0 && Hc(e.element, { bottom: 25 }).isInViewport === !1)
    throw new z("Ad is not in viewport", Un);
}
var st = { exports: {} };
st.exports = Pn;
function Pn(e, t) {
  var n = {}, r;
  return this && this.constructor.name == "Array" ? (t = e, e = this) : arguments.length === 0 && (e = []), t && t.length ? (Array.isArray(t) || (t = [t]), t.forEach(function(i) {
    n[i] = {};
  }), e.forEach(function(i) {
    t.forEach(function(s) {
      r = zc(i, s), r = Array.isArray(r) ? r : [r], r.forEach(function(o) {
        n[s].hasOwnProperty(o) || (n[s][o] = []), n[s][o].push(i);
      });
    });
  })) : e.forEach(function(i) {
    Object.keys(i).forEach(function(s) {
      r = i[s], !(typeof r == "object" && !Array.isArray(r)) && (n.hasOwnProperty(s) || (n[s] = {}), r = Array.isArray(r) ? r : [r], r.forEach(function(o) {
        n[s].hasOwnProperty(o) || (n[s][o] = []), n[s][o].push(i);
      }));
    });
  }), n;
}
function zc(e, t, n) {
  var r = /\./gi, i, s, o, a;
  if (r.test(t))
    for (s = t.split(r), o = e, a = 0; a < s.length; a++)
      if (i = s[a], a < s.length - 1) {
        if (!o.hasOwnProperty(i))
          return n;
        o = o[i];
      } else
        return o[i];
  else
    return e[t];
}
st.exports.enableArrayIndexPrototype = function() {
  Array.prototype.index = Pn;
};
var Gc = st.exports;
const Wc = Gc, Cn = [
  {
    id: 1,
    aliases: [
      "Attractions"
    ],
    name: "Attractions",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "150"
    }
  },
  {
    id: 2,
    aliases: [
      "Automotive"
    ],
    name: "Automotive",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "1",
      openrtbId: "IAB2",
      cattax1: "IAB2"
    }
  },
  {
    id: 3,
    aliases: [
      "Books and Literature"
    ],
    name: "Books and Literature",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "42",
      openrtbId: "IAB1-1",
      cattax1: "IAB1-1"
    }
  },
  {
    id: 4,
    aliases: [
      "Business and Finance"
    ],
    name: "Business and Finance",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "52",
      openrtbId: "IAB3",
      cattax1: "IAB3"
    }
  },
  {
    id: 5,
    aliases: [
      "Careers"
    ],
    name: "Careers",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "123",
      openrtbId: "IAB4",
      cattax1: "IAB4"
    }
  },
  {
    id: 6,
    aliases: [
      "Communication"
    ],
    name: "Communication",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "80DV8O"
    }
  },
  {
    id: 7,
    aliases: [
      "Crime"
    ],
    name: "Crime",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "380"
    }
  },
  {
    id: 8,
    aliases: [
      "Disasters"
    ],
    name: "Disasters",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "381"
    }
  },
  {
    id: 9,
    aliases: [
      "Education"
    ],
    name: "Education",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "132",
      openrtbId: "IAB5",
      cattax1: "IAB5"
    }
  },
  {
    id: 10,
    aliases: [
      "Entertainment"
    ],
    name: "Entertainment",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "JLBCU7",
      openrtbId: "IAB1",
      cattax1: "IAB1"
    }
  },
  {
    id: 11,
    aliases: [
      "Events"
    ],
    name: "Events",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "8VZQHL"
    }
  },
  {
    id: 12,
    aliases: [
      "Family and Relationships"
    ],
    name: "Family and Relationships",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "186",
      openrtbId: "IAB6",
      cattax1: "IAB6"
    }
  },
  {
    id: 13,
    aliases: [
      "Fine Art"
    ],
    name: "Fine Art",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "201",
      openrtbId: "IAB1-3",
      cattax1: "IAB1-3"
    }
  },
  {
    id: 14,
    aliases: [
      "Food & Drink"
    ],
    name: "Food & Drink",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "210",
      openrtbId: "IAB8",
      cattax1: "IAB8"
    }
  },
  {
    id: 15,
    aliases: [
      "Genres"
    ],
    name: "Genres",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "SPSHQ5"
    }
  },
  {
    id: 16,
    aliases: [
      "Healthy Living"
    ],
    name: "Healthy Living",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "223"
    }
  },
  {
    id: 17,
    aliases: [
      "Hobbies & Interests"
    ],
    name: "Hobbies & Interests",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "239",
      openrtbId: "IAB9",
      cattax1: "IAB9"
    }
  },
  {
    id: 18,
    aliases: [
      "Holidays"
    ],
    name: "Holidays",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "1KXCLD"
    }
  },
  {
    id: 19,
    aliases: [
      "Home & Garden"
    ],
    name: "Home & Garden",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "274",
      openrtbId: "IAB10",
      cattax1: "IAB10"
    }
  },
  {
    id: 20,
    aliases: [
      "Law"
    ],
    name: "Law",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "383",
      openrtbId: "IAB11",
      cattax1: "IAB11"
    }
  },
  {
    id: 21,
    aliases: [
      "Maps & Navigation"
    ],
    name: "Maps & Navigation",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "WQC6HR"
    }
  },
  {
    id: 22,
    aliases: [
      "Medical Health"
    ],
    name: "Medical Health",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "286"
    }
  },
  {
    id: 23,
    aliases: [
      "Music"
    ],
    name: "Music",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "338"
    }
  },
  {
    id: 24,
    aliases: [
      "Personal Celebrations & Life Events"
    ],
    name: "Personal Celebrations & Life Events",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "163"
    }
  },
  {
    id: 25,
    aliases: [
      "Personal Finance"
    ],
    name: "Personal Finance",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "391",
      openrtbId: "IAB13",
      cattax1: "IAB13"
    }
  },
  {
    id: 26,
    aliases: [
      "Pets"
    ],
    name: "Pets",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "422",
      openrtbId: "IAB16",
      cattax1: "IAB16"
    }
  },
  {
    id: 27,
    aliases: [
      "Politics",
      "News and Politics"
      //this is found in TextRazor
    ],
    name: "Politics",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "386",
      openrtbId: "IAB11",
      cattax1: "IAB11"
    }
  },
  {
    id: 28,
    aliases: [
      "Pop Culture"
    ],
    name: "Pop Culture",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "432"
    }
  },
  {
    id: 29,
    aliases: [
      "Productivity"
    ],
    name: "Productivity",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "W3CW2J"
    }
  },
  {
    id: 30,
    aliases: [
      "Real Estate"
    ],
    name: "Real Estate",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "441",
      openrtbId: "IAB21",
      cattax1: "IAB21"
    }
  },
  {
    id: 31,
    aliases: [
      "Religion & Spirituality"
    ],
    name: "Religion & Spirituality",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "453",
      openrtbId: "IAB23",
      cattax1: "IAB23"
    }
  },
  {
    id: 32,
    aliases: [
      "Science"
    ],
    name: "Science",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "464",
      openrtbId: "IAB15",
      cattax1: "IAB15"
    }
  },
  {
    id: 33,
    aliases: [
      "Sensitive Topics"
    ],
    name: "Sensitive Topics",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "v9i3On"
    }
  },
  {
    id: 34,
    aliases: [
      "Shopping"
    ],
    name: "Shopping",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "473",
      openrtbId: "IAB22",
      cattax1: "IAB22"
    }
  },
  {
    id: 35,
    aliases: [
      "Sports"
    ],
    name: "Sports",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "483",
      openrtbId: "IAB17",
      cattax1: "IAB17"
    }
  },
  {
    id: 36,
    aliases: [
      "Style & Fashion"
    ],
    name: "Style & Fashion",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "552",
      openrtbId: "IAB18",
      cattax1: "IAB18"
    }
  },
  {
    id: 37,
    aliases: [
      "Technology & Computing"
    ],
    name: "Technology & Computing",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "596",
      openrtbId: "IAB19",
      cattax1: "IAB19"
    }
  },
  {
    id: 38,
    aliases: [
      "Travel"
    ],
    name: "Travel",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "653",
      openrtbId: "IAB20",
      cattax1: "IAB20"
    }
  },
  {
    id: 39,
    aliases: [
      "Video Gaming"
    ],
    name: "Video Gaming",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "680",
      openrtbId: "IAB9-30",
      cattax1: "IAB9-30"
    }
  },
  {
    id: 40,
    aliases: [
      "War and Conflicts"
    ],
    name: "War and Conflicts",
    type: "iab",
    tier: 1,
    meta: {
      iabtlId: "389"
    }
  }
], Vc = Wc(Cn, ["aliases", "name", "meta.cattax1"]);
var Jc = {
  IabCategories: Cn,
  IndexedBy: Vc
};
const { name: Kc } = Jc.IndexedBy;
function tu(e) {
  if (!e)
    return [];
  const t = e.filter((n) => n.type === "iab").map((n) => {
    const r = Kc[n.value];
    if (!r || r.length === 0)
      return null;
    const i = r[0];
    return !i || !i.meta ? null : i.meta.cattax1;
  }).filter((n) => !!n);
  return Wo(t);
}
export {
  z as AdvertisingError,
  Dn as ERR_INVALID_PARTNER,
  Ie as ERR_MISSING_REQUIRED_OPTION,
  Un as ERR_NOT_IN_VIEWPORT,
  Vt as ERR_NO_AD_FILL,
  Ct as MACRO_MAP,
  H as adSizes,
  Bn as canFit,
  Yc as getAdSizes,
  Ko as getMappedValue,
  $n as getMaxSize,
  Xc as getTagsFromContext,
  Qc as partners,
  eu as renderAdvert,
  Jo as replaceMacrosInString,
  Vo as replaceMacrosInURL,
  qe as sendBeacon,
  Zo as setInnerHTML,
  tu as toIabTax1Ids,
  Zc as trackClick,
  qc as validateAdvertisementRequest
};
